import { memo } from 'react';
import { AppealStatus, AppealVersion, V2JuryStage, V2Stage1Result, V2Stage2Result } from '../../types/appeals';
import { getV2QueueBadge } from '../../utils/appealsV2';
import { cn } from '../../utils/cn';

interface AppealVersionBadgeProps {
  appeal: {
    appeal_version?: AppealVersion | null;
    status: AppealStatus;
    v2_jury_stage?: V2JuryStage | null;
    v2_stage1_result?: V2Stage1Result | null;
    v2_stage2_result?: V2Stage2Result | null;
  };
  className?: string;
}

/**
 * Queue / list badge for the Jury V2 flow:
 * - "V1 Jury" for legacy appeals currently in jury
 * - "V2 · Stage 1/2" while a V2 jury is voting
 * - outcome badges ("✔ Removed", "✘ Unappealable", ...) for decided V2 appeals
 * Renders nothing when no badge applies (e.g. V2 appeals before the jury phase).
 */
export const AppealVersionBadge = memo(({ appeal, className }: AppealVersionBadgeProps) => {
  const badge = getV2QueueBadge(appeal);
  if (!badge) return null;

  return (
    <span className={cn(
      'badge',
      badge.className,
      className,
    )}>
      {badge.label}
    </span>
  );
});
